export default {
  completed: 'completed',
  revised: 'revised',
  pending: 'pending',
}
